import React from 'react';
import './CircleArrowButton.css';

interface CircleArrowButtonProps {
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
}

const CircleArrowButton: React.FC<CircleArrowButtonProps> = ({ 
  onClick, 
  className = '',
  ariaLabel = 'Navigate'
}) => {
  return (
    <button 
      className={`circle-arrow-button ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <span className="circle-arrow-button__circle" />
      <span className="circle-arrow-button__arrow" />
    </button>
  );
};

export default CircleArrowButton;